/**
 * Signal-Schlüssel: Dashboard-Karte „Jetzt blüht" bittet den Editor, beim
 * Öffnen direkt in den Blüh-Modus zu springen (#270 / #609). Einmalig gesetzt,
 * beim Editor-Mount konsumiert (gelesen + sofort gelöscht).
 */
export const BLOOM_AUTOSTART_KEY = 'gartenplaner_bloom_autostart';

/**
 * Liest das Auto-Start-Signal und löscht es (einmaliger Konsum).
 * @returns {boolean} true, wenn der Blüh-Modus direkt geöffnet werden soll
 */
export function consumeBloomAutostart() {
  try {
    if (sessionStorage.getItem(BLOOM_AUTOSTART_KEY) === '1') {
      sessionStorage.removeItem(BLOOM_AUTOSTART_KEY);
      return true;
    }
  } catch {
    // sessionStorage nicht verfügbar — Editor öffnet ohne Auto-Blüh-Modus
  }
  return false;
}
